import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

const LeaveReview = () => (
  <Wrapper>
    <a href="/employer/pending_reviews#/" title="Review Pending">
      <FontAwesomeIcon icon={faPencilAlt} />
      <div>review pending</div>
    </a>
  </Wrapper>
);

export const Wrapper = styled.div`
  padding-right: 10px;
  font-size: 0.8em;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
  z-index: 1;
  background: #fff;

  &:hover {
    a {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

export default LeaveReview;
